import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';
import { toast } from '@/components/ui/toast';
import { api } from '@/lib/api';
import { ApiError } from '@/lib/api-errors';

interface KioskScreenLinkProps {
  id: string;
  name: string;
}

export const KioskScreenLink = ({ id, name }: KioskScreenLinkProps) => {
  const { t: tErrors } = useTranslation('errors');

  return (
    <button
      type="button"
      className="inline-flex rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2"
      onClick={() => {
        void api
          .post<{ url: string }>(`/attendance/kiosks/${id}/display`)
          .then((result) => {
            window.open(result.url, '_blank', 'noopener,noreferrer');
          })
          .catch((error: unknown) => {
            toast.error(
              error instanceof ApiError ? tErrors(error.code, error.params) : tErrors('UNEXPECTED'),
            );
          });
      }}
    >
      <Badge variant="neutral" className="cursor-pointer transition-colors hover:bg-surface-sunken">
        {name}
      </Badge>
    </button>
  );
};
